import { createSlice } from '@reduxjs/toolkit';

import { initialState, userSettingsAdapter } from './user-settings.state';
import { userSettingsReducers } from './actions';

const userSettings = createSlice({
  name: 'userSettings',
  initialState: userSettingsAdapter.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    userSettingsReducers(builder);
  },
});

export const userSettingsReducer = userSettings.reducer;
